import * as Yup from 'yup';
import { RegularExpressions } from '../../../../TCSMApp/global/constants/regular-expressions';
import { EcdParishSettingsProps } from '../../models/epi-model';

const defaultFieldOnlySpacesMessage = 'The field should not be only white spaces.';

export interface ParishQuickSearchFormValues {
	name?: string;
	cityOrCountry?: string;		
	type?: string;	
	zip_code?: string;
	location?: string;
}

export function QuickSearchFormValidationSchema(parishSettings: EcdParishSettingsProps){	
   return Yup.object().shape({			
	name: Yup.string().nullable().matches(RegularExpressions.StringNotOnlySpaces, parishSettings?.fieldOnlySpacesMessage || defaultFieldOnlySpacesMessage),
	type: Yup.string().nullable().matches(RegularExpressions.StringNotOnlySpaces, parishSettings?.fieldOnlySpacesMessage || defaultFieldOnlySpacesMessage),
	cityOrCountry: Yup.string().nullable().matches(RegularExpressions.StringNotOnlySpaces, parishSettings?.fieldOnlySpacesMessage || defaultFieldOnlySpacesMessage),
	zip_code: Yup.string().nullable().matches(RegularExpressions.StringNotOnlySpaces, parishSettings?.fieldOnlySpacesMessage || defaultFieldOnlySpacesMessage),	   	
   });
}

export interface ParishNameQuickSearchResult {
	name: string;
	party_id: string;	
	short_address?: string;
}

export interface ParishLocationQuickSearchResult {
	location: string;	
}

export interface Address {
	address1: string;
	address2?: any;
	address3?: any;
	city: string;
	state: string;
	postal_code: string;
	country: string;
}

export interface Parish {
	id: string;
	name: string;
	address?: Address;
	number?: string;
	fax?: string;
	type?: string;	
	maps_link?: string;
}

export enum ParishSearchSort{
	NameAsc = 'name',
	ZipCodeDesc = 'zip_code_desc',
	CityAsc = 'city',
	StateAsc = 'state',
	NameDesc = 'name_desc',
	CityDesc = 'city_desc',
	StateDesc = 'state_desc',
	ZipCodeAsc = 'zip_code',
}

export interface ParishFilters {
	name?: string;
	type?: string;	
	zip_code?: string;
	location?: string;	
	sort?: ParishSearchSort;
	page?: string;
}

export class ParishQueryStringParameters {
	public static readonly Name = 'name';

	public static readonly Type = 'type';

	public static readonly ZipCode = 'zip_code';

	public static readonly Location = 'location';

	public static readonly Sort = 'sort';

	public static readonly Page = 'page';
}

export enum SearchContext{
	Search = 'search',	
	Results = 'results',	
	Detail = 'detail',	
	DetailClergy = 'detailClergy',	
	Mail = 'mail',	
}

// Parish detail
export interface Clergy {
	first_name?: string;
	middle_name?: string;
	last_name?: string;
	suffix?: any;
	id: string;
}

export interface ParishComplete extends Parish {	
	website?: string;
	email?: string;	
	diocese?: string;	
	clergy_count?: number;
	clergy?: Clergy[];
}
